/**
 * Which links a HELM page opens in the app (A7Y-5210), as a router path:
 *   - an admin page, as a path (`/admin/…`) or a URL on an Apptonomy host
 *     (HELM's run writes production's absolute URL into its facts);
 *   - the generated `pipeline.md`'s `#acct-…` anchor → that account's page;
 *   - the generated `helm-roster.md` → This week.
 * Everything else is null: it is not a page of this app.
 */

const APP_HOST_RE = /(^|\.)apptonomy\.ai$|^localhost$|^127\.0\.0\.1$/;
const ACCOUNT_ANCHOR_RE = /^#(acct-[a-z0-9]+(?:-[a-z0-9]+)*)$/;

export const HELM_WEEK_PATH = '/admin/cmo/crm/this-week';

export function inAppPath(href: string): string | null {
  const raw = href.trim();
  if (raw.startsWith('/admin/')) return raw;
  let url: URL;
  try {
    url = new URL(raw);
  } catch {
    return null;
  }
  if (url.protocol !== 'https:' && url.protocol !== 'http:') return null;
  if (APP_HOST_RE.test(url.hostname) && url.pathname.startsWith('/admin/'))
    return `${url.pathname}${url.search}${url.hash}`;
  if (url.pathname.endsWith('/pipeline.md')) {
    const anchor = ACCOUNT_ANCHOR_RE.exec(url.hash);
    return anchor ? `/admin/cmo/crm/${anchor[1]}` : null;
  }
  if (url.pathname.endsWith('/helm-roster.md')) return HELM_WEEK_PATH;
  return null;
}
